import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from '../../universal-nav/hooks/useUniversalNavContext';
import type { Currency } from '@zapier/currency';

interface CurrencyRaw {
  id: string;
  name: string;
  multiplier: number;
  symbol: string;
  icon: string;
  zero_decimal: boolean;
}

const formatCurrenciesData = (
  currenciesData: Array<CurrencyRaw>
): Array<Currency> => {
  return currenciesData.map((currency) => ({
    id: currency.id,
    name: currency.name,
    icon: currency.icon,
    multiplier: currency.multiplier,
    symbol: currency.symbol,
    zeroDecimal: currency.zero_decimal,
  }));
};

export const useQueryGetCurrencies = () => {
  const { apiHostname } = useUniversalNavContext();
  const result = useQuery<
    Array<CurrencyRaw>,
    unknown /* error type */,
    Array<Currency>
  >({
    queryKey: ['getCurrencies'],
    queryFn: async () => {
      const response = await fetch(`${apiHostname}/api/v4/currencies/rates`, {
        credentials:
          process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const currencyJson = await response.json();
      return currencyJson.objects;
    },
    select: formatCurrenciesData,
  });

  return result;
};
